export interface JwtPayload {
	exp?: number;
	iat?: number;
	[key: string]: unknown;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
	try {
		const segment = token.split('.')[1];
		if (!segment) {
			return null;
		}
		const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
		return JSON.parse(atob(base64)) as JwtPayload;
	} catch {
		return null;
	}
}

export function getJwtExpMs(token: string): number | null {
	const exp = decodeJwtPayload(token)?.exp;
	return typeof exp === 'number' ? exp * 1000 : null;
}

/** Milliseconds until `exp`, or null when `exp` is missing. */
export function getJwtTtlMs(token: string, nowMs = Date.now()): number | null {
	const expMs = getJwtExpMs(token);
	if (expMs === null) {
		return null;
	}
	return expMs - nowMs;
}

export function isJwtExpiringWithin(
	token: string,
	leadMs: number,
	nowMs = Date.now(),
): boolean {
	const ttl = getJwtTtlMs(token, nowMs);
	if (ttl === null) {
		return true;
	}
	return ttl <= leadMs;
}

/** Delay before proactive refresh; null when `exp` is missing (refresh immediately). */
export function getJwtRefreshDelayMs(
	token: string,
	leadMs: number,
	nowMs = Date.now(),
): number | null {
	const ttl = getJwtTtlMs(token, nowMs);
	if (ttl === null) {
		return null;
	}
	return Math.max(0, ttl - leadMs);
}
